import { render } from "./AddTyreImg.vue?vue&type=template&id=27e6d1f0&scoped=true"
import script from "./AddTyreImg.vue?vue&type=script&lang=js"
export * from "./AddTyreImg.vue?vue&type=script&lang=js"

import "./AddTyreImg.vue?vue&type=style&index=0&id=27e6d1f0&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-27e6d1f0"]])

export default __exports__